<template>
  <div class="col mt-6">
    <h6 class="header-pretitle">
      {{ schoolInfo }}
    </h6>
    <h1 class="header-title">
      {{ studentName }}
    </h1>
    <p class="text-no-muted" v-if="route == 'Home'">
      <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan online sınav ekranına geçiş sağlayabilirsin.
    </p>
    <p class="text-no-muted" v-if="route == 'HomeWork'">
      <i class="fe fe-help-circle"></i> Sevgili Öğrencimiz,
      <ul>
        <li>Öncelikle “Online Sınav” için en uygun cihaz Windows işletim sistemine sahip bir bilgisayar ve <a href="https://www.google.com.tr/intl/tr/chrome/" target="_blank">Google Chrome</a> internet tarayıcısıdır. Sorunsuz bir online sınav deneyimi için mümkünse bu cihaz ve tarayıcıyı tercih etmeni öneriyoruz.</li>
        <li>Sınavdan önce mutlaka bilgisayarının saatini kontrol etmelisin. Bilgisayar saatin hatalıysa mutlaka düzeltmelisin.</li>
        <li>Sınav başlama süresi geldiğinde sınavın aktif olması için sayfa yenilemesi yapabilirsin.</li>
        <li>Sınavı verilen bitiş süresinden önce tamamlamalısın.</li>
        <li>Sınava ilk başladığında sınav süren de başlar. Sağ üstte kalan süreni dakika ve saniye olarak görebilirsin ve bu süre içerisinde sınavını tamamlamalısın.</li>
        <li>Soru numaraları üstteki şeritte yer almaktadır. Buradan istediğin soru numarasına tıklayarak doğrudan soruya geçiş yapabilirsin.</li>
        <li>Soruların çözümü için ekranını kullanabilirsin.</li>
        <li>Bir soru için bir cevap şıkkını işaretledikten sonra vazgeçmek istiyorsan cevap şıklarının altında yer alan “Bu soruyu boş bırak” ifadesini tıklayarak seçimini kaldırabilirsin.</li>
        <li>Herhangi bir nedenle sınav sayfasından çıkmışsan tekrar bağlandığında sınav başlama saatine göre kalan süren varsa sınavına devam edebilirsin.</li>
        <li>Tüm soruları cevaplandırdıktan sonra istersen sınav süresinin sonuna kadar bekleyebilir, istersen “Sınavdan Çık” ifadesini tıklayarak çıkış yapabilirsin.</li>
        <li>Sınav soru gösterim modunu Optik Görünüm / Normal Görünüm olarak değişim sağlayabilirsiniz.</li>
        <li>Başarılar dileriz.</li>
      </ul>
    </p>
    <p class="text-no-muted" v-if="route == 'HomeWorkDetail'">
      <span v-if="this.exam_status == true">
        <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan sınavına giriş sağlayabilirsin. <strong>Sınavı Başlat</strong> butonuna bastığında {{ this.minute }} dakikalık süren başlar.
        <br />
        Başarılar diliyoruz...
      </span>
      <span v-else-if="this.exam_status == null">
        <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, sınavın başladı. Soruları düzgün okuyarak cevaptan emin olunca yanıtlamanda ve emin olmadığın soruları boş bırakmanda fayda var. <br />
        Boş bırakmak istediğin soruda bir cevap işaretlediysen, işaretlediğin cevaba tekrar tıklayarak cevabı kaldırabilirsin.
      </span>
      <span v-else>
        <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, sınavın bitti. <strong>Sınav Sonuçları</strong> ekranından sınavla ilgili durumunu görebilirsin.
        <br />
        Ayrıca sorular arasında geçiş yaparak doğru ve yanlış cevapları kontrol edebilirsin.
      </span>
    </p>
  </div>
</template>
<script>
import base from '@/mixins/base';
export default {
  name: 'Head',
  mixins: [ base ],
  props: {
    route: { type: String, required: true, default: 'Home' },
    exam_status: { type: [Boolean, String], required: false, default: false },
    minute: { type: String, required: false, default: '40' }
  },
  data() {
    return {
      type: this.route,
      time_alert: '',
      device_time: '',
      real_time: '',
      redirect_check: 0,
      schoolInfo: '',
      studentOnlyName: '',
      studentName: '',
    }
  },
  mounted() {
    if (this.$store.state.auth.student_id != null) {
      let student = this.$store.state.auth.student;
      this.schoolInfo = student.okul + ' - ' + student.sinif + '/' + student.sube
      this.studentOnlyName = student.isim_soyisim.split(" ")[0]
      this.studentName = student.isim_soyisim
    } else {
      let x = setInterval(() => {
        if (this.$store.state.auth.student_id != null) {
          let student = this.$store.state.auth.student;
          this.schoolInfo = student.okul + ' - ' + student.sinif + '/' + student.sube
          this.studentOnlyName = student.isim_soyisim.split(" ")[0]
          this.studentName = student.isim_soyisim
          clearInterval(x);
        }
      }, 50);
    }
  }
}
</script>